const imgurl = {
  icon1: require("./overviewpage/teamwork.png"),
  icon2: require("./overviewpage/equality.png"),
  icon3: require("./overviewpage/completed-task.png"),
  icon4: require("./overviewpage/calendar.png"),
  logo: require("./headerpage/logo.png"),
  user: require("./loginicons/user.png"),
  fingerprint: require("./loginicons/fingerprint.png"),
  openEye: require("./loginicons/openEye.png"),
  closedEye: require("./loginicons/closedEye.png"),
  close: require("./loginicons/close.png"),
};

export default imgurl;
